/** La cuenta atrás tras varios fallos seguidos: 75 → «1:15». */
export function formatearEspera(segundos: number): string {
  const m = Math.floor(segundos / 60);
  const s = segundos % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
